import { r4Client, r4Error } from '@/services'
import useLogger from '@/composables/useLogger'
const logger = useLogger('SqlDatasourceApi')

const SqlDatasourceApi = {
  /**
   * SQL Datsource Templates
   */

  async fetchSqlDatasources (queryParams) {
    try {
      const resp = await r4Client().get('/api/v1/sql_datasources', { params: queryParams })
      return resp.data
    } catch (error) {
      throw new Error(r4Error(error))
    }
  },

  async getSqlDatasource (datasourceId) {
    try {
      const resp = await r4Client().get('/api/v1/sql_datasources/' + datasourceId)
      return resp.data
    } catch (error) {
      throw new Error(r4Error(error))
    }
  },

  async saveSqlDatasource (sqlDatasource) {
    try {
      const saveOp = function () {
        if (sqlDatasource.id) {
          logger.trace(`API Updating sql template ${sqlDatasource.id}`)
          return r4Client().put(`/api/v1/sql_datasources/${sqlDatasource.id}`, sqlDatasource)
        } else {
          logger.trace('Creating Sql Datasource')
          return r4Client().post('/api/v1/sql_datasources', sqlDatasource)
        }
      }
      const resp = await saveOp()
      return resp.data
    } catch (error) {
      throw new Error(r4Error(error))
    }
  },

  async executeQuery (outputFormat, sqlDatasource) {
    try {
      const resp = await r4Client().post(`/api/v1/sql_datasources/execute_query`, { ...sqlDatasource, output_format: outputFormat })
      return resp.data
    } catch (error) {
      throw new Error(r4Error(error))
    }
  },

  async deleteSqlDatasource (sqlDatasource) {
    try {
      const resp = await r4Client().delete(`/api/v1/datasources/${sqlDatasource.id}`)
      return resp.data
    } catch (error) {
      throw new Error(r4Error(error))
    }
  },

  async getAvailableConnections () {
    try {
      const resp = await r4Client().get('/api/v1/sql_datasources/connections')
      return resp.data
    } catch (error) {
      throw new Error(r4Error(error))
    }
  }
}

export default SqlDatasourceApi
